import { Utils } from 'common';
import isObject from 'lodash/isObject';
import HistoryUtil from '../utils/Util';

const { Util } = Utils;

const Print = rawData => {
	const data = Util.toCamelCase(rawData);
	const printDetails = isObject(data.printDetails) ? data.printDetails : {};

	return {
		...data,
		printDetails: {
			...printDetails,
			trackingStatusDate: HistoryUtil.convertGmtTimeToLocalTime(
				printDetails.trackingStatusDate
			),
			shipDate: new Date(printDetails.shipDate),
		},

		// TODO: revisit here as refund_requested_date does not show up in the response
		refundRequestedDate: HistoryUtil.convertGmtTimeToLocalTime(
			data.refundRequestedDate
		),

		transactionDate: HistoryUtil.convertGmtTimeToLocalTime(
			data.transactionDate
		),
	};
};

export default Print;
